export const SAVE_APPSETTINGS = 'uistate/SAVE_APPSETTINGS';
export const LOAD_LABELS = 'uistate/LOAD_LABELS';
export const SAVE_SHELLSETTINGS = 'uistate/SAVE_SHELLSETTINGS';
export const LOAD_SHELLSETTINGS = 'uistate/LOAD_SHELLSETTINGS';
export const SAVE_HEIGHTPARAM = 'uistate/SAVE_HEIGHTPARAM';
export const SAVE_WIDTHPARAM = 'uistate/SAVE_WIDTHPARAM';
export const SAVE_GRID_FILTERS = 'uistate/SAVE_GRID_FILTERS';

export const SET_DEBUG_LABELS = 'uistate/SET_DEBUG_LABELS';